/**
 * @generated SignedSource<<673544d5fe298c6301a3cd4affb905a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProfileProjectStatusUpdatesPage_viewer$data = {
  readonly projectOwner: boolean | null;
  readonly disableNotifications: boolean | null;
  readonly company: {
    readonly forecastDemo: boolean | null;
    readonly tier: TierType | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileProjectStatusUpdates_viewer" | "SettingsProfileSubNav_viewer">;
  readonly " $fragmentType": "ProfileProjectStatusUpdatesPage_viewer";
};
export type ProfileProjectStatusUpdatesPage_viewer$key = {
  readonly " $data"?: ProfileProjectStatusUpdatesPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileProjectStatusUpdatesPage_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileProjectStatusUpdatesPage_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastDemo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileProjectStatusUpdates_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsProfileSubNav_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c102696a5d8696a93f54e686974b0d9c";

export default node;
